import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import TinyHousePage from './pages/TinyHousePage';
import NaturePage from './pages/NaturePage';
import HostPage from './pages/HostPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import BrochurePage from './pages/BrochurePage';
import RentPage from './pages/RentPage';
import AdminPage from './pages/AdminPage';
import CookieConsent from './components/CookieConsent';
import MetaPageView from './components/MetaPageView';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <MetaPageView />
        <Navigation />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/your-country-cabin" element={<TinyHousePage />} />
            <Route path="/your-landscape" element={<NaturePage />} />
            <Route path="/your-host" element={<HostPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/brochure" element={<BrochurePage />} />
            <Route path="/pitch-fee" element={<RentPage />} />
            <Route path="/rent" element={<Navigate to="/pitch-fee" replace />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            {/* Redirects for old URLs */}
            <Route path="/tiny-house" element={<Navigate to="/your-country-cabin" replace />} />
            <Route path="/nature" element={<Navigate to="/your-landscape" replace />} />
            <Route path="/host" element={<Navigate to="/your-host" replace />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;